document.documentElement.classList.remove('no-js');

const initializeBrandCarousels = (root = document) => {
  root.querySelectorAll('[data-brand-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;

    const collection = carousel.closest('.brand-collection, .pet-collection, .shop-collection, .brand-story-products');
    const track = carousel.querySelector('[data-carousel-track]');
    const previous = collection?.querySelector('[data-carousel-previous]');
    const next = collection?.querySelector('[data-carousel-next]');
    if (!track || !previous || !next) return;

    const move = (direction) => {
      track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.85, 260), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    carousel.dataset.initialized = 'true';
  });
};

const initializeProductGalleries = (root = document) => {
  root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.initialized === 'true') return;

    const track = gallery.querySelector('[data-gallery-track]');
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = gallery.querySelector('[data-gallery-current]');
    if (!track || slides.length < 2 || !previous || !next) return;

    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    const updateCounter = () => {
      if (!current || track.clientWidth === 0) return;
      const index = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      current.textContent = String(index + 1);
    };

    let frame;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateCounter);
    }, { passive: true });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    gallery.dataset.initialized = 'true';
  });
};

const initializeProductForms = (root = document) => {
  root.querySelectorAll('.product-form').forEach((form) => {
    if (form.dataset.initialized === 'true') return;

    const variantData = form.querySelector('[data-product-variants]');
    const variantInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const addText = form.querySelector('[data-add-to-cart-text]');
    const price = form.closest('.main-product')?.querySelector('[data-product-price]');
    if (!variantData || !variantInput || !addButton || !addText) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    const updateVariant = () => {
      const selectedOptions = Array.from(form.querySelectorAll('.product-option')).map((option) => {
        return option.querySelector('[data-option-value]:checked')?.value;
      });
      const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));

      if (!variant) {
        variantInput.value = '';
        addButton.disabled = true;
        addText.textContent = addButton.dataset.unavailableLabel;
        return;
      }

      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
      if (price) {
        price.innerHTML = `${variant.compareAt ? `<s>${variant.compareAt}</s>` : ''}<span>${variant.price}</span>`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.querySelectorAll('[data-option-value]').forEach((option) => option.addEventListener('change', updateVariant));
    form.dataset.initialized = 'true';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initializeBrandCarousels();
  initializeProductGalleries();
  initializeProductForms();
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menuButton.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        document.body.classList.remove('menu-open');
      });
    });
  }
});

document.addEventListener('shopify:section:load', (event) => {
  initializeBrandCarousels(event.target);
  initializeProductGalleries(event.target);
  initializeProductForms(event.target);
});
